import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FeaturesModule } from '@features/features.module';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { NgxStripeModule } from 'ngx-stripe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderService } from '@core/services/loader/loader.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from '@core/helpers/loader.interseptor';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { GTM_ID } from '@root/app.config';
import { VariantService } from '@core/services/variant/variant.service';
import { FooterComponent } from '@shared/footer/footer.component';
import { environment } from '@env';

export function initVariantFactory(vs: VariantService) {
	return () => vs.init();
}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
	return new TranslateHttpLoader(http);
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		SharedModule,
		CoreModule,
		FeaturesModule,
		BrowserAnimationsModule,
		HttpClientModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		GoogleTagManagerModule.forRoot({
			id: GTM_ID,
		}),
		FooterComponent,
		NgxStripeModule.forRoot(environment.stripePublicKey),
	],
	providers: [
		VariantService,
		{
			provide: APP_INITIALIZER,
			useFactory: initVariantFactory,
			deps: [VariantService],
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: LoaderInterceptor,
			multi: true,
		},
		LoaderService,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
